import { useEffect, useState } from 'react'

const useAnimation = (list: any) => {
  const [emoji, setEmoji] = useState(list[0])

  useEffect(() => {
    const interval = setInterval(
      () => {
        const randomEmoji = list[Math.floor(Math.random() * list.length)]
        setEmoji(randomEmoji)
      },
      Math.floor(Math.random() * 1600) + 400
    )
    return () => clearInterval(interval)
  }, [emoji])

  return {
    emoji,
  }
}

export default useAnimation
